<template>
    <li v-if="showAnything"
        class="data-list__item">
        <span class="data-list__item__label">{{ label }}</span>
        <span v-if="showValue"
              class="data-list__item__data">{{ value }}</span>
        <hh-data-list v-else
                      class="data-list__item__data-list"
                      :items="item[1]" />
    </li>
</template>

<script>

import Casing from '@/helpers/casing'

export default {

    props: {
        item: {
            type: Array,
            required: true,
        },
    },

    computed: {

        label() {
            return Casing.startCase(this.item[0])
        },

        value() {
            return Array.isArray(this.item[1]) ? null : this.item[1]
        },

        hasValue() {
            return this.item[1] !== undefined && this.item[1] !== null
        },

        isHiddenProperty() {
            // We want to hide common key reference variable names here as well as items prefixed with '_' (private) and '$' (just not to show)
            return this.item[0] === null || !this.item[0].length || this.item[0][0] === '_' || this.item[0][0] === '$'
                || this.item[0] === 'id'
        },

        showValue() {
            return this.hasValue && typeof this.item[1] !== 'object' && this.item[1] !== ''
        },

        showSubObject() {
            return this.hasValue && typeof this.item[1] === 'object'
        },

        showAnything() {
            return !this.isHiddenProperty && (this.showValue || this.showSubObject)
        },
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.

.data-list {

    @include element('item') {

        @include element('label') {
            font-weight: bold;

            &:after {
                content: ': '
            }
        }

        @include element('data-list') {
            @include styled-data-list
        }
    }
}

</style>
